import RunEnrich from "pages/RunEnrich";
import Dashboard from "pages/Dashboard";
import Login from "pages/Login";
import Logs from "pages/Logs";
import Schedules from "pages/Schedules";

const routes = [
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: <Dashboard />,
    children: [
      { path: "/", element: <RunEnrich /> },
      { path: "/logs", element: <Logs /> },
      { path: "/schedules", element: <Schedules /> },
    ],
  },
];

export default routes;
